import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useAuth } from "./authContext";
import { db } from "../firebase";
import { onValue, ref, set, get, child, serverTimestamp } from 'firebase/database'
import { formatWebData } from "../components/helpers/formatWebData";
import { formatRealtimeData } from "../components/helpers/formatRealtimeData";
import { formatRegisterData } from "../components/helpers/formatRegisterData";

export const dataContext = createContext();

export const useData = () => {
    const context = useContext(dataContext);
    if (!context) throw new Error('No hay proveedor de autenticación');
    return context;
}

export function DataProvider({ children }) {
    const [dataFirebase, setDataFirebase] = useState(null);
    const [loadData, setLoadData] = useState(true);
    const [cantPanels, setCantPanels] = useState({});
    const [brightness, setBrightness] = useState({});
    const [dataSelect, setDataSelect] = useState(null);
    const internetCheckRunningRef = useRef([]);
    const { user } = useAuth();


    const updateLock = (id, locked) => {
        const idx = internetCheckRunningRef.current.findIndex(l => l.id === id);
        (idx !== -1) ? internetCheckRunningRef.current[idx].locked = locked : internetCheckRunningRef.current.push({ id, locked });
    };

    const checkAllInternetConnections = async (dataFirebase) => {

        if (internetCheckRunningRef.current.some(item => item.locked)) {
            // console.log("Proceso ya en ejecución. No se reinicia.");
            return;
        }

        try {
            const items = Object.entries(dataFirebase || {});

            items.forEach(([indexData, item]) => {
                checkInternetConnection(indexData);
            });

        } catch (error) {
            console.error("Error al enviar multiples:", error);
        }
    };

    const checkInternetConnection = async (indexData) => {

        try {

            updateLock(indexData, true);
            const basePath = `${user.Mine}/Blasting_Panel/Address/${indexData}/Alarms/InternetConect`;
            const pathRead = ref(db, `${basePath}/Read`);
            const pathTs = ref(db, `${basePath}/ts`);
            const pathState = ref(db, `${basePath}/State`);

            await set(pathRead, true);
            await set(pathTs, serverTimestamp());

            await new Promise(resolve => setTimeout(resolve, 90000));

            const snapshotRead = await get(pathRead);
            const currentRead = snapshotRead.exists() ? snapshotRead.val() : null;

            if (currentRead === true) await set(pathState, false);
        } catch (error) {
            console.error("Error al verificar conexión:", error);
        } finally {
            updateLock(indexData, false);
        }
    };


    // const updateData = async (dataUpdate) => {
    //     // setLoadData(true)
    //     try {
    //         const dataRealtime = formatRealtimeData(dataUpdate)
    //         for (const [key, value] of Object.entries(dataRealtime)) {
    //             await set(ref(db, `${user.Mine}/Blasting_Panel/Address/${dataSelect.IndexData}/Fields/${key}/Text`), value);
    //         }
    //         return true;
    //     } catch (errors) {
    //         return null;
    //     } finally {
    //         // setLoadData(false);
    //     }
    // }

    const updateData = async (dataUpdate, dataCheckBoxs) => {
        try {
            const dataRealtime = formatRealtimeData(dataUpdate)
            let hasChangeData = false;
            for (const [keyDataCheckBoxs, valueDataCheckBoxs] of Object.entries(dataCheckBoxs)) {
                if (valueDataCheckBoxs) {
                    const dataReformat = formatRealtimeData(dataFirebase[keyDataCheckBoxs].dataFields)
                    for (const [key, value] of Object.entries(dataRealtime)) {
                        if (dataReformat[key] !== value) {
                            hasChangeData = true;
                        }
                        await set(ref(db, `${user.Mine}/Blasting_Panel/Address/${keyDataCheckBoxs}/Fields/${key}/Text`), value);
                        await updateRS485(key, keyDataCheckBoxs)
                    }
                    await updateBrightness(dataUpdate, keyDataCheckBoxs);
                    await updateLastChange(keyDataCheckBoxs);
                    if (hasChangeData) {
                        await updateRegister(dataUpdate, keyDataCheckBoxs)
                    }
                }
            }
            return true;
        } catch (errors) {
            return null;
        }
    }

    const updateRegister = async (dataUpdate, indexData) => {
        try {
            // console.warn(dataUpdate)
            const nowDate = new Date().toISOString();
            const namePanel = dataFirebase[indexData]['dataInfo']['Name']
            const newRegister = formatRegisterData(dataUpdate, user.email, namePanel, nowDate)
            // console.warn(newRegister)
            await set(ref(db, `${user.Mine}/Record/${nowDate.slice(0, 19)}/Panel ${indexData}`), newRegister);
            return true;
        } catch (errors) {
            return null;
        }
    }

    const updateLastChange = async (indexData) => {
        try {
            const basePath = `${user.Mine}/Blasting_Panel/Address/${indexData}/Alarms/LastChange`;
            await set(ref(db, `${basePath}/LastChangeListened`), false);
            await set(ref(db, `${basePath}/LastChangeMade`), false);
            await set(ref(db, `${basePath}/ts`), serverTimestamp());

            return true;
        } catch (errors) {
            return null;
        }
    }

    const updateBrightness = async (dataUpdate, indexData) => {
        try {
            const basePath = `${user.Mine}/Blasting_Panel/Address/${indexData}/Brightness`;
            await set(ref(db, `${basePath}/Day`), dataUpdate.brightnessDay);
            await set(ref(db, `${basePath}/Night`), dataUpdate.brightnessNight);

            return true;
        } catch (errors) {
            return null;
        }
    }

    const updateRS485 = async (keyRS485, indexData) => {
        try {
            await set(ref(db, `${user.Mine}/Blasting_Panel/Address/${indexData}/Alarms/RS485_COM/Fields/${keyRS485}/Update/last_message`), false);
            await set(ref(db, `${user.Mine}/Blasting_Panel/Address/${indexData}/Alarms/RS485_COM/Fields/${keyRS485}/Update/ts`), serverTimestamp());
            await set(ref(db, `${user.Mine}/Blasting_Panel/Address/${indexData}/Alarms/RS485_COM/Fields/${keyRS485}/Set/last_message`), false);
            await set(ref(db, `${user.Mine}/Blasting_Panel/Address/${indexData}/Alarms/RS485_COM/Fields/${keyRS485}/Set/ts`), serverTimestamp());
            return true;
        } catch (errors) {
            return null;
        }
    }

    const getRegister = async (dateRange) => {
        try {
            const snapshot = await get(child(ref(db), `${user.Mine}/Record`));

            if (!snapshot.exists()) return false;

            const data = Object.entries(snapshot.val()).flatMap(([fechaRegistro, panels]) => {
                const fechaUTC = new Date(fechaRegistro + "Z"); // <- Aquí está la corrección

                // console.log(fechaUTC)
                // console.log(panels)
                // console.log(dateRange)
                // console.log(dataFirebase)
                // console.log(cantPanels)
                // console.log(user)


                const horas = fechaUTC.toLocaleTimeString('es-PE', { hour12: false });
                const fechaDia = fechaUTC.toLocaleDateString('es-PE').replaceAll('/', '-');
                const fechaFormateada = `${horas}, ${fechaDia}`;

                return Object.entries(panels).map(([panel, details]) => {
                    // console.warn(panel)
                    // console.warn(details)
                    return {
                        namePanel: panel==='Panel 0' ? 'PANEL DE VOLADURA OFICINAS' : 'PANEL DE VOLADURA CHINA',
                        ...details,
                        updateTime: fechaFormateada
                    };
                });
                // return Object.entries(panels).map(([panel, details]) => ({ ...details, idPanel: panel, updateTime: fechaRegistro }));
            });
            // console.log("data --> ", data)
            data.reverse();
            return data;

        } catch (errors) {
            console.error("salio el siguiente error: ", errors)
            return false;
        }
    }

    const resetMaster = async (indexData) => {
        try {
            if (indexData === undefined || indexData === null) {
                console.error("No se recibió IndexData para reiniciar el Master");
                return false;
            }

            const path = `${user.Mine}/Blasting_Panel/Address/${indexData}/Force_Reset/Master_Force`;

            await set(ref(db, path), true);

            console.log(`Solicitud de reinicio Master enviada al panel ${indexData}`);

            return true;

        } catch (error) {
            console.error("Error solicitando reinicio del Master:", error);
            return false;
        }
    };


    const resetRouter = async (indexData) => {
        try {
            if (indexData === undefined || indexData === null) {
                console.error("No se recibió IndexData para reiniciar el Router");
                return false;
            }

            const path = `${user.Mine}/Blasting_Panel/Address/${indexData}/Force_Reset/Router_Force`;

            await set(ref(db, path), true);

            console.log(`Solicitud de reinicio eléctrico enviada al panel ${indexData}`);

            return true;

        } catch (error) {
            console.error("Error solicitando reinicio eléctrico:", error);
            return false;
        }
    };

    useEffect(() => {
        setLoadData(true);
        if (!user) {
            setDataFirebase(null);
            setLoadData(true);
            setCantPanels(null);
            return;
        }
        const dataRef = ref(db, `${user.Mine}/Blasting_Panel/UI_PANEL_SETTINGS`);
        onValue(dataRef, (snapshot) => {
            if (snapshot.exists()) {
                const macList = Object.values(snapshot.val().MAC_LIST || {}).filter(
                    item =>
                        typeof item === 'number' &&
                        !Number.isNaN(item)
                );    
                setCantPanels({ val: macList, mine: user.Mine })
                setBrightness(snapshot.val().Brightness)
            } else {
                setCantPanels(null)
                setLoadData(false);
            }
        }, (error) => {
            console.error('Error fetching data:', error);
            setCantPanels(null)
            setLoadData(false);
        });

    }, [user])

    useEffect(() => {
        setLoadData(true);
        const listeners = [];
        if (!cantPanels || !cantPanels.val) {
            return;
        }

        const fetchedData = {};

        const fetchData = (item, key, path) => {
            const dataRef = ref(db, `${cantPanels.mine}/Blasting_Panel/Address/${item}/${key}`);
            return new Promise((resolve) => {
                let stateListener = false;
                onValue(dataRef, (snapshot) => {
                    if (snapshot.exists()) {
                        if (stateListener) {
                            setDataFirebase((prev) => ({
                                ...prev,
                                [item]: {
                                    ...prev[item],
                                    [`${path}`]: path === 'dataFields' ? formatWebData(snapshot.val()) : snapshot.val()
                                }
                            }));
                        }
                        resolve(snapshot.val());
                        stateListener = true;
                    } else {
                        console.warn(`No data available for ${item} -> ${key}`);
                        resolve(null);
                    }
                }, (error) => {
                    console.error('Error fetching data:', error);
                    resolve(null);
                });
            });
        };

        const promises = Object.values(cantPanels.val).map((item, index) => {
            fetchedData[item] = {};
            return Promise.all([
                fetchData(item, 'Info', 'dataInfo').then(data => fetchedData[item].dataInfo = data),
                fetchData(item, 'Alarms', 'statePanel').then(data => fetchedData[item].statePanel = data),
                fetchData(item, 'Brightness', 'brightnessPanel').then(data => fetchedData[item].brightnessPanel = data),
                fetchData(item, 'Fields', 'dataFields').then(data => {
                    const dataFormat = formatWebData(data);
                    fetchedData[item].dataFields = dataFormat
                }),
                fetchData(item, 'Force_Reset', 'resetPanel').then(data => fetchedData[item].resetPanel = data),
            ]);
        });

        Promise.all(promises).then(() => {
            setDataFirebase(fetchedData);
            setLoadData(false);
        });

        return () => {
            listeners.forEach(unsubscribe => unsubscribe());
        };
    }, [cantPanels]);



    return <dataContext.Provider 
                value={{ 
                    user,
                    dataFirebase, 
                    brightness, 
                    loadData, 
                    dataSelect, 
                    updateData, 
                    setDataSelect, 
                    getRegister, 
                    checkAllInternetConnections,
                    resetMaster,
                    resetRouter,
                }}>
                {children}    
            </dataContext.Provider>;
}

